var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditMagazzino',{attrs:{"id":_vm.id,"duplicateId":_vm.duplicateId}})}
var staticRenderFns = []

export { render, staticRenderFns }